<div *ngIf="!field.hide || builder">
    <div *ngIf="field.view_type == 'autocomplete' ">
        <mat-form-field color="accent" [ngClass]="{'happ-small-form-field-outline': field.smallField}" floatLabel="always" appearance="outline" fxFlex>
            <mat-label>{{field.title | translate}}</mat-label>
            <input matInput placeholder="{{field.title | translate}}" [(ngModel)]="emailModel" (blur)="onKeyPress()" fxFlex #temp (keyup)="changed(temp.value)" [disabled]="field.showdisablecontroltype=='true' || field.disable" [hidden]="field.hidden" aria-label="State" [matAutocomplete]="auto">
            <mat-autocomplete (optionSelected)="selectUser()" #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredNames" [value]="option.email">
                    <span>{{ option.email }}</span>
                </mat-option>
            </mat-autocomplete>
            <div class="error-message" *ngIf="errorMessage && (!min_error && !max_error)">
                {{ errorMessage | translate }}
            </div>
        </mat-form-field>
    </div>
    <div *ngIf="field.view_type == 'dropdown' ">
        <mat-form-field color="accent"  floatLabel="always" appearance="outline" [ngClass]="{'happ-small-form-field-outline': field.smallField}" fxFlex>
            <mat-label>{{field.title | translate}}</mat-label>
            <mat-select placeholder="{{field.title | translate}}" fxFlex (selectionChange)="selectUser()" [(ngModel)]="emailModel" [disabled]="field.showdisablecontroltype=='true' || field.disable" [hidden]="field.hidden">
                <!-- <mat-option>  </mat-option> -->
                <mat-optgroup *ngFor="let group of groups" [label]="group.name">
                    <mat-option *ngFor="let user of group.users" [value]="user.email">
                        {{ user.email }}
                    </mat-option>
                </mat-optgroup>
            </mat-select>
            <div class="error-message" *ngIf="errorMessage && (!min_error && !max_error)">
                {{ errorMessage | translate }}
            </div>
        </mat-form-field>
    </div>
</div>
